import Vue from 'vue'

const errcfg = {
  appName: 'crm-web',
  clientType: 1,
}

function sendErr(msg, trace) {
  const data = {
    message: msg,
    trace: trace,
    appName: errcfg.appName,
    clientType: errcfg.clientType,
  }
  const xmlhttp = new window.XMLHttpRequest()
  const reportUrl = 'https://weixin.drip.im/api-monitor/log/client/report'
  xmlhttp.open('POST', reportUrl)
  xmlhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
  xmlhttp.send(JSON.stringify(data))
}

Vue.config.errorHandler = function (err, vm, info) {
  let trace
  try {
    trace = err.stack.split('\n')
  } catch (err) {
  }
  console.error(err)
  sendErr(err.message, trace)
}

window.onerror = function (msg, source, lineno, colno, err) {
  let trace
  try {
    trace = err.stack.split('\n')
  } catch (err) {

  }
  console.error(err)
  sendErr(msg, trace)

}



export default {}
